import { isValid, parse, startOfDay } from "date-fns";
import { Assort } from "../../models/Assort";
import { Instructor } from "../../models/Instructor";
import { ExerciseFiltersObject } from "./hooks/useAdditionalHooks";

const parseDbId = (value?: string): { objectDb: number; objectId: number } | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;

  const [dbRaw, idRaw] = trimmed.split(",");
  const objectDb = Number(dbRaw);
  const objectId = Number(idRaw);
  if (!Number.isFinite(objectDb) || !Number.isFinite(objectId)) return undefined;
  if (objectDb === 0 && objectId === 0) return undefined;

  return { objectDb, objectId };
};

export const parseScheduleDate = (value?: string): Date | undefined => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  const parsed = parse(trimmed, "yyyy-MM-dd", new Date());
  return isValid(parsed) ? startOfDay(parsed) : undefined;
};

/** Channel filters are "db,id". Empty values stay unset so the schedule shows everything. */
export const buildScheduleFilters = (
  exerciseGroup?: string,
  zone?: string,
  instructor?: string,
): ExerciseFiltersObject => {
  const filters = {} as ExerciseFiltersObject;
  const group = parseDbId(exerciseGroup);
  const zoneId = parseDbId(zone);
  const human = parseDbId(instructor);

  if (group) filters.exerciseGroups = group as Assort;
  if (zoneId) filters.zones = zoneId as Assort;
  if (human) filters.humans = human as Instructor;

  return filters;
};
